import React, { useState, useEffect } from "react";
import brands1 from "../assets/images/brands1.jpg";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import MotevafaImg from "../assets/images/motevafa.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";
import sia, {IMG_DIR, SOUND_DIR, WEB_URL} from "../services/Api";
import { map } from "lodash";
import LoaderView from "../tools/LoaderView";
import headerBanner from '../assets/images/header-poster1.jpg'
import { notifySuccessful, notifySuccessfulMessage, notifyWarnMessage } from "../App";
import { Select, MenuItem } from "@material-ui/core";

const Motevafa = (props) => {
  const dead_id = props.match.params.id;

  const [dead, setDead] = useState([]);
  const [eradatHa, setEradatHa] = useState([]);
  const [salavat, setSalavat] = useState(0);
  const [namaz, setNamaz] = useState(0);
  const [fatehe, setFatehe] = useState(0);
  const [doa, setDoa] = useState(0);
  const [khatm, setKhatm] = useState(0);

  const [userName, setUserName] = useState(null);
  const [userPhone, setUserPhone] = useState(null);
  const [userMessage, setUserMessage] = useState(null);

  const [isLoading, setLoading] = useState(true);
  const [isLoadingShomaresh, setLoadingShomaresh] = useState(false);

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    setLoading(true)
    setDead([])
    setEradatHa([])
    await sia
      .getDataFromServer("/dead/" + dead_id)
      .then((res) => {
        const data = res.data
        console.log(res.data)
        map(data?.shomarsh, (item) => {
          data.prays.forEach((pray) => {
            if (pray._id == item.pray_id) {
              pray.count = item.count
            }
          })
          item?.pray_id == "6060860e519be832921f8632" &&
            setSalavat(item?.count);
          item?.pray_id == "606086286d38095ff8211ee7" && setNamaz(item?.count);
          item?.pray_id == "606086382161013668492896" && setFatehe(item?.count);
        });
        getEradatHaaa()
        console.log(data,res.data)
        setDead(data);
      })
      .catch((err) => {
        // console.log(err);
      });
    setLoading(false)
  }

  const getEradatHaaa = async () => {
    setLoading(true)
    await sia
      .getDataFromServer("/comment?dead_id=" + dead_id)
      .then((res) => {
        setEradatHa(res.data)
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false)
  }

  const handleCounter = (e) => {
    e.persist();
    e.preventDefault();
    const countUp = e.target.dataset.countup;
    var pray_ref = null;
    if (countUp == "salavat") {
      pray_ref = "6060860e519be832921f8632";
      setSalavat(salavat + 1);
    } else if (countUp == "namazVahshat") {
      pray_ref = "606086286d38095ff8211ee7";
      setNamaz(namaz + 1);
    } else if (countUp == "fatehe") {
      pray_ref = "606086382161013668492896";
      setFatehe(fatehe + 1);
    }

    const postBody = {
      pray_id: pray_ref,
      type: "dead",
    };

    sia
      .PostDataToServer("/addToShomarsh/" + dead_id, postBody)
      .then((res) => {
        console.log(res.data[0].count);
      })
      .catch((err) => console.log(err));
  };

  const sendEradat = async () => {
    if (!userName || userName.length == 0) {
      notifyWarnMessage('لطفا نام خود را وارد کنید')
      return
    } else if (!userPhone || userPhone.length != 11) {
      notifyWarnMessage('لطفا شماره خود را وارد کنید')
      return
    } else if (!userMessage || userMessage.length == 0) {
      notifyWarnMessage('لطفا متن را وارد کنید')
      return
    }
    setLoading(true)
    await sia.PostDataToServer('comment', {
      "name": userName,
      "phone": userPhone,
      "message": userMessage,
      "confirm": "1",
      "dead_id": dead._id
    }).then((res) => {
      if (res.status == 200) {
        notifySuccessfulMessage('با موفقیت ثبت شد')
        setUserName('')
        setUserMessage('')
        setUserPhone('')
        getData()
      }
    }).catch((err) => console.log(err))
  }

  const read = async (prayId, index) => {
    setLoadingShomaresh(true)
    const postBody = {
      pray_id: prayId,
    }

    await sia
      .PostDataToServer("/addToShomarsh/" + dead_id, postBody)
      .then((res) => {
        if (res.status == 200) {
          notifySuccessful()
          var isAdded = false
          dead.prays?.forEach((item) => {
            if (item._id == prayId) {
              isAdded = true
              dead.prays[index].count ? dead.prays[index].count += 1 : dead.prays[index].count = 1
              setDead(dead)
            }
          })
          if (!isAdded) {
            dead.shomarsh.push({ pray_id: prayId, count: 1 })
            setDead(dead)
          }
        }
      })
      .catch((err) => console.log(err));
    setLoadingShomaresh(false)
  };

  const [selectedSoundIndex, setSelectedSoundIndex] = useState(0)

  return (
    <>
      {isLoading ? <LoaderView /> : <div>
        <header>
          <div className="pagewrapper" id="header-big">
            <TopNav />
            <div className="header-poster poster1" style={{ objectFit: 'cover', backgroundImage: dead ? `url(${IMG_DIR + dead.pictureHeader})` : `url(${headerBanner})` }}>
              <div className="container">
                <div className="motevafa-item box-sizing radius10">
                  <img
                    src={IMG_DIR + dead.picture}
                    alt=""
                    className="motevafa-thumb radius10"
                    width
                    height
                  />
                  <h3 className="motevafa-title box-sizing">{dead.name}</h3>
                  <div className="motevafa-date">
                    <span>ولادت : {dead.birthday}</span>
                    <span>وفات : {dead.deathDate}</span>
                  </div>
                  <p className="motevafa-text box-sizing">{dead.disc}</p>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="clear" />
        <div className="pagewrapper" id="statistics">
          <div className="container">
            <div className="right-col">
              <div className="stat-item box-sizing">
                <span>{salavat}</span>
                صلوات ها
              </div>
              <div className="stat-item box-sizing">
                <span>{fatehe}</span>
                فاتحه ها
              </div>
              <div className="stat-item border0 box-sizing">
                <span>{namaz}</span>
                نماز وحشت
              </div>
            </div>
          </div>
        </div>
        <div className="pagewrapper" id="motevafa-buttons">
          <div className="container box-sizing radius10">
            <a
              onClick={handleCounter}
              data-countUp="salavat"
              href
              title
              className="btn box-sizing radius10 ease"
            >
              ذکر صلوات
            </a>
            <a
              onClick={handleCounter}
              data-countUp="fatehe"
              href
              title
              className="btn box-sizing radius10 ease"
            >
              قرائت فاتحه
            </a>
            <a
              onClick={handleCounter}
              data-countUp="namazVahshat"
              href
              title
              className="btn box-sizing radius10 ease"
            >
              خواندن نماز وحشت
            </a>
          </div>
        </div>
        <div className="pagewrapper" id="motevafa-mazar">
          <div className="container box-sizing radius10">
            <img src={IMG_DIR + dead.pictureAddress} alt="" className="radius10" width height />
            <p className="box-sizing">
              <span>آدرس مزار :</span>
              {dead.address}
            </p>
          </div>
        </div>
        <div className="pagewrapper" id="motevafa-eradat">
          <div className="container">
            <h2 className="main-title">عرض ارادت</h2>
            <form action id="eradat-form" onSubmit={sendEradat} method="post">
              <input
                type="text"
                name="fname"
                placeholder="نام و نام خانوادگی"
                className="input box-sizing radius10"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
              <input
                type="text"
                name="phone"
                placeholder="شماره تماس"
                value={userPhone}
                onChange={(e) => setUserPhone(e.target.value)}
                className="input box-sizing radius10"
              />
              <textarea
                name="message"
                placeholder="متن ارادت"
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                className="input message box-sizing radius10"
              />
              <input
                type="submit"
                className="submit ease box-sizing radius10"
                value="ارسال"
              />
            </form>
          </div>
        </div>
        <div className="pagewrapper" id="khatm-ghoran-player">
          <div className="container">
            <h2 className="main-title">ادعیه و ختم ها</h2>
            {isLoadingShomaresh ? <LoaderView /> : <ul className="khatm-player-list">
              {dead.prays?.map((item, prayIndex) => <li className="item box-sizing radius10">
                <h3 className="title">{item.name}<span className="stat">(خوانده شده: {item.count ?? 0})</span></h3>
                <audio controls>
                  <source src={SOUND_DIR + item.sounds[selectedSoundIndex]?.sound ?? ''} type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>
                <a title onClick={() => read(item._id, prayIndex)} className="btn radius10 ease box-sizing mouse-cursor-pointer">تقبل قرائت</a>
                <Select
                  className="select blue radius10 box-sizing ease"
                  value={selectedSoundIndex}
                  onChange={(e) => setSelectedSoundIndex(e.target.value)}>
                  {item.sounds.map((sound, index) => <MenuItem value={index}>{sound.nameGhari}</MenuItem>
                  )}
                </Select>
                {/* <select name="ghaari" onChange={(e) => {
                  setSelectedSoundIndex(e.target.value)
                }} className="select custom-select blue radius10 box-sizing ease">
                  <option value={-1}>انتخاب قاری</option>
                  {item.sounds.map((sound, index) => <option value={index}>{sound.nameGhari}</option>
                  )}
                </select> */}
              </li>)}
            </ul>}
            <div className="clear" />
          </div>
        </div>
        <div className="pagewrapper" id="khatm-ghoran-player">
          <div className="container">
            <h2 className="main-title">ارادت ها</h2>
            <ul className="khatm-player-list">
              {eradatHa.map((item) => <li className="item box-sizing radius10">
                <h3 className="title">{item.message+ " ( از طرف " + item.name + " )"}<span className="stat">{item.name}</span></h3>
              </li>)}
            </ul>
            <div className="clear" />
          </div>
        </div>
        <div className="clear" />
        <Footer />
      </div>}
    </>
  );
};

export default Motevafa;
